<template>
  <div class="navbarComponent">
    <div class="container-sm">
      <div class="inside">
        <div class="case-status">
          <el-row justify="space-between" style="width: 100%">
            <el-col :xl="12" :lg="12">
              <ul
                v-if="
                  getCaseInformation &&
                  getCaseInformation.accession_data &&
                  getCaseInformation.accession_data.length > 0
                "
              >
                <li>
                  <h3 class="name">Accession Id</h3>
                </li>
                <li v-for="(accession, index) in getCaseInformation.accession_data" :key="index">
                  <el-button
                    class="btn-success"
                    @click="goToCaseView(getCaseInformation.case_id)"
                  >
                    <span class="pr-5">{{ accession.accession_id }}</span>
                  </el-button>
                </li>
              </ul>
            </el-col>
            <el-col :xl="12" :lg="12">
              <ul
                class="justify-content-end"
                v-if="getCaseInformation && getCaseInformation.status"
              >
                <li>
                  <h3 class="name">Order Status</h3>
                </li>
                <li>
                  <div
                    class="column-status"
                    v-if="
                      getCaseInformation.status
                    "
                  >
                    <div>
                      <el-tag
                        :type="getStatusType(getCaseInformation.status)"
                        style="cursor: not-allowed"
                      >
                        <span v-if="getCaseInformation.status == 'COMPLETE'">
                          FINALIZED
                        </span>
                        <span
                          v-else-if="getCaseInformation.status == 'PARTIAL'"
                        >
                          PARTIAL
                        </span>
                        <span v-else>
                          {{ getCaseInformation.status.split("_").join(" ") }}
                        </span>
                      </el-tag>
                    </div>
                  </div>
                  <div v-else class="column-status">
                    <el-tag :type="getStatusType(getCaseInformation.status)">
                      {{
                        getCaseInformation.status === "COMPLETE"
                          ? "FINALIZED"
                          : getCaseInformation.status.split("_").join(" ")
                      }}
                    </el-tag>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
  <section
    class="new-case-view case-creation"
    id="single-case-view"
    v-loading="loading"
  >
    <div class="case-view-body">
      <div class="container-sm">
        <section id="view-case-screen">
          <PatientInformation></PatientInformation>
          <span class="case-creation__divider"></span>
          <CaseInformation></CaseInformation>
          <span class="case-creation__divider"></span>
          <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Order Codes</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <el-row :gutter="15">
              <el-col
                :xl="3"
                :lg="4"
                :md="8"
                :sm="12"
                :xs="12"
              >
                <div class="input-value view-cases">
                  <p
                    class="value"
                    style="
                      background: #bf1b39;
                      width: 180px;
                      height: 18px;
                      border-radius: 10px;
                      padding-left: 14px;
                      color: white;
                    "
                  >
                    <span v-if="getCaseInformation && getCaseInformation.order_codes">
                      {{ getCaseInformation.order_codes.join(', ') }}
                    </span>
                  </p>
                </div>
              </el-col>
              </el-row>
          </div>
          </div>
           <span class="case-creation__divider"></span>
          <div v-if="isCaseHavingAdditionalNotes">
            <AdditionalNotes></AdditionalNotes>
          </div>
          <span class="case-creation__divider"></span>
          <Medication></Medication>
          <div v-if="hasBillingType">
            <BillingInformation></BillingInformation>
            <span class="case-creation__divider"></span>
          </div>
          <TestAttachments></TestAttachments>
          <span class="case-creation__divider"></span>
          <!-- <div v-if="!this.getAuthenticatedUser.allow_unathorized_access">
            <ErequisitionForm></ErequisitionForm>
          </div> -->
        </section>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/orders/PatientInformations")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/orders/CaseInformations")
);
const Medication = defineAsyncComponent(() =>
  import("@/components/orders/MedicationView")
);
const TestAttachments = defineAsyncComponent(() =>
  import("@/components/orders/TestAttachments")
);
// const ErequisitionForm = defineAsyncComponent(() =>
//   import("@/components/orders/Erequisition")
// );
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const AdditionalNotes = defineAsyncComponent(() =>
  import("@/components/orders/AdditionalNotes")
);
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/orders/BillingInformations")
);
export default {
  components: {
    PatientInformation,
    CaseInformation,
    Medication,
    TestAttachments,
    //ErequisitionForm,
    AdditionalNotes,
    TestAttachments,
    BillingInformation
  },
  data() {
    return {
      scrollPosition: null,
      loading: false,
      drawer: false,
      takeStatusChangeReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
      tubeInformationFromChild: [],
      refetchTestInfo: false,
    };
  },
  mixins: [UserPermissionsHelper],
  ...mapGetters("auth", ["getAuthenticatedUser"]),
  computed: {
    ...mapGetters("orders", [
      "getCaseInformation",
      "getShowMedication",
      "getUpdateOrderStatus",
    ]),
    hasBillingType() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.billing_type &&
        this.getCaseInformation.billing_type == "INSURANCE"
      ) {
        return true;
      }
      return false;
    },
    isCaseHavingAdditionalNotes() {
      if (this.getCaseInformation && this.getCaseInformation.order_notes) {
        return true;
      }
      return false;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
  },
  async mounted() {
    this.orderId = this.$route.params.order_id;
    await this.fetchOrderInformation();
    this.toggleBodyClass("addClass", "fixedNavbarBody");
    // Scroll
    window.addEventListener("scroll", this.updateScroll);
    if (this.$route.query && this.$route.query.drawer) {
      this.drawer = true;
    }
  },
  async unmounted() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    handleTubeInfoUpdate(updatedData) {
      this.tubeInformationFromChild = updatedData;
    },
    updateViewOrder(resp) {
      if (resp) {
        this.fetchOrderInformation();
      }
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      // For example, adding a class 'scrolled' when the user scrolls more than 100px
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    async toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    async fetchOrderInformation() {
      try {
        this.loading = true;
        await this.$store.dispatch("orders/fetchCaseInformation", {
          order_id: this.$route.params.order_id,
        });
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    closeDrawer() {
      this.drawer = false;
      this.$router.push({ query: { ...this.$route.query, drawer: undefined } });
      this.$emit("close", true);
    },
  },
};
</script>
<style lang="scss">
.case-view-body {
  .view-cases {
    &.search-btn {
      ul {
        padding-bottom: 10px;
        li {
          .search-with-filter-input {
            position: relative;
            .el-select {
              .el-input__inner {
                cursor: pointer;
                display: inline-flex;
                height: 35px;
                background: #ffffff;
                border: 1px solid #e0e0e0;
                box-shadow: none;
                color: #000;
                max-width: 158px;
                padding-left: 30px;
                border-radius: 6px;
                position: relative;
              }
              .el-input__suffix {
                background: #0a5da6;
                border-radius: 0 5px 5px 0;
                right: 0;
                height: 97%;
              }
            }
            .search-icon {
              position: absolute;
              top: 17px;
              left: 7px;
              bottom: 199px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .search-accession {
            position: relative;
            .el-input {
              .el-input__inner {
                min-height: 35px;
                border-radius: 5px;
                padding-right: 20px;
                height: 35px;
              }
            }
            .search-icon {
              position: absolute;
              right: 5px;
              top: 7px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
  .case-creation__card {
    .edit-view {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .view-cases {
      .el-input__inner {
        height: 30px;
      }
      .value {
        color: #0a2342;
        font-size: 13px;
        font-weight: 500;
      }
    }

    .case-creation__heading {
      .btn {
        min-height: 30px;
        .edit-icon {
          display: flex;
          align-items: center;
          margin-right: 10px;
          p {
            color: #828282;
          }
        }
        margin: 0;
        padding: 0;
        border: none;
        img {
          margin-right: 6px;
          width: 15px;
          height: 15px;
        }
        &:focus {
          background-color: #fff;
        }
        &:hover {
          background-color: #fff;
        }
      }
    }
  }
  .case-creation__footer {
    .look-up-button {
      background: #273480;
      border-radius: 5px;
      color: #ffffff;
      font-weight: 600;
      padding: 8px 19px 8px 19px;
      min-height: 20px;
    }
  }
}
.order-status-reason {
  margin-bottom: 5px;
  .bg-white {
    background: #fff;
    padding: 10px;
    border-radius: 6.40567px;
  }
  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      position: relative;
      &:not(:last-child) {
        p {
          &:after {
            content: ",";
          }
          color: #333;
        }
      }
      .reason-heading {
        text-transform: uppercase;
        color: #333;
        margin-right: 0;
        font-size: 13px;
        color: #f24a55;
      }
      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0;
        line-height: 1.5;
      }

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
.case-status {
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  justify-content: space-between;
  li {
    button {
      cursor: default;
    }
  }
}
</style>
